import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceLeft4.vue?vue&type=template&id=70b78e62&"
import script from "./FaceDirectionResultEffectFaceLeft4.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceLeft4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports